@if (canExportPdf()) {
  <p-button
    [outlined]="true"
    icon="pi pi-upload"
    [label]="'impactReport.tripHeader.exportPdf' | transloco"
    (onClick)="openDialog()"
  />
} @else {
  <app-locked-button
    [label]="'impactReport.tripHeader.exportPdf' | transloco"
    [limitedFeature]="limitedFeature"
  />
}

<p-dialog
  [(visible)]="showDialog"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '30rem' }"
  [header]="'impactReport.pdfOptions.title' | transloco"
>
  <div class="flex flex-col gap-3">
    <!-- Langue -->
    <div>
      <label class="text-paragraph-sm-med text-greyscale-700" for="lang">
        {{ "impactReport.pdfOptions.language" | transloco }}
      </label>
      <p-select
        id="lang"
        [options]="languages"
        [(ngModel)]="options.lang"
        optionLabel="label"
        optionValue="value"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>

    <!-- Par voyageur -->
    <div>
      <label class="text-paragraph-sm-med text-greyscale-700" for="datatype">
        {{ "impactReport.pdfOptions.datatype" | transloco }}
      </label>
      <p-selectbutton
        id="dataType"
        [options]="[
          {
            label: 'impactReport.pdfOptions.global' | transloco,
            value: false,
          },
          {
            label: 'impactReport.pdfOptions.individual' | transloco,
            value: true,
          },
        ]"
        [(ngModel)]="options.perTraveler"
        [ngModelOptions]="{ standalone: true }"
        aria-label="Select data type global emission or individual emission"
        class="mb-4 w-full"
      />
    </div>

    <!-- Logo affiché sur les graphiques du PDF -->
    @if (logoSources.length > 0) {
      <div>
        <label class="text-paragraph-sm-med text-greyscale-700" for="logoPosition">
          {{ "impact.overview.logo.label" | transloco }}
        </label>
        <p-selectbutton
          id="logoPosition"
          [options]="logoPositionOptions"
          [(ngModel)]="options.logoPosition"
          [ngModelOptions]="{ standalone: true }"
          optionLabel="label"
          optionValue="value"
          class="w-full"
        />
        @if (options.logoPosition !== "none" && logoSources.length > 1) {
          <label
            class="text-paragraph-sm-med mt-2 block text-greyscale-700"
            for="logoSource"
          >
            {{ "impact.overview.logo.source" | transloco }}
          </label>
          <p-select
            id="logoSource"
            [options]="logoSources"
            [(ngModel)]="options.logoSourceId"
            optionLabel="name"
            optionValue="id"
            [style]="{ width: '100%' }"
          ></p-select>
        }
      </div>
    }

    <!-- Graphiques -->
    <div>
      <p class="text-paragraph-sm-med text-greyscale-700">
        {{ "impactReport.graphLabels.title" | transloco }}
      </p>
      <div
        class="flex max-h-60 flex-col gap-1 overflow-y-auto rounded-md border p-2"
      >
        @for (graph of graphsOptions; track $index) {
          <div class="flex flex-1 items-center">
            <p-checkbox
              [(ngModel)]="options.selectedGraphs"
              [value]="graph"
              [id]="graph"
              class="mr-2"
            ></p-checkbox>
            <label
              class="text-paragraph-xs-med text-greyscale-700"
              [for]="graph"
            >
              {{ "impactReport.graphLabels." + graph | transloco }}
            </label>
          </div>
        }
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="{{ 'impactReport.cancel' | transloco }}"
      icon="pi pi-times"
      [outlined]="true"
      (onClick)="showDialog = false"
    ></p-button>

    <p-button
      label="{{ 'travelBoards.download' | transloco }}"
      icon="pi pi-download"
      [loading]="loading"
      (onClick)="download()"
    ></p-button>
  </ng-template>
</p-dialog>
